var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{attrs:{"element-type":_vm.elementType,"tag":"div"}},[_c('input',{attrs:{"id":_vm.recaptchaId,"name":"g-recaptcha-response","type":"hidden"},domProps:{"value":_vm.tokenValue}}),_c('div',{ref:"scriptContainer"})])}
var staticRenderFns = []

export { render, staticRenderFns }